import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import xTwitterIcon from '../components/icons/xTwitterIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: "mdi",
		values: {
			"x-twitter": {
				component: xTwitterIcon,
			}
		}
	}
});
